module.exports = __webpack_public_path__ + "static/img/STL.2e9542f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/STL.png
// module id = wXzJ
// module chunks = 34